<template>
    <v-dialog v-model="modalpolicyprivacy" width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{language==='English'?'Terms of service and privacy policy':'Términos de servicio y politica de privacidad'}}</span>
        </v-card-title>
        <v-card-text>
          {{language==='English'?'1- Anyone who subscribes accepts the HiProyect conditions and regulations based on company rules and laws as well as international rules. Always promoting good ethical and moral understanding towards other subscribers.':'1- Toda persona que se suscriba acepta las condiciones y regulaciones de HiProyect basado en reglas y leyes de la compañía como también reglas internacionales. Promoviendo siempre la buena intensión ética y moral para con los demás suscriptores.'}}
          </v-card-text>
          <v-card-text>
          {{language==='English'?'2- The professional or person who subscribes to HiProyect must provide reliable information.':'2- El profesional o persona que se suscriba a HiProyect debe proveer información fidedigna.'}}
          </v-card-text>
          <v-card-text>
          {{language==='English'?'3- The communication between subscribers must be in a language appropriate for all ages, races, gender, skin color, country of origin, etc.':'3- La comunicación entre suscriptores debe ser con una lengua apropiada para toda edad, raza, genero, color de piel, pais de procedencia, etc.'}}
          </v-card-text>
          <v-card-text>
          {{language==='English'?`4- The projects uploaded to the subscriber's account must be original, developed or created by the subscriber himself.`:'4- Los proyectos subidos a la cuenta del suscriptor deberán ser originales, desarrollados o creados por el mismo suscriptor.'}}
          </v-card-text>
          <v-card-text>
          {{language==='English'?`5- Hi Proyect is not responsible for authorship matters. If any subscriber or subscribers break the company rules (Hi Proyect) and international copyright rights, they must be judged according to law.`:'5- Hi Proyect no se responsabiliza por asuntos de autoría. Si algún suscriptor o suscriptores rompen las reglas de la compañía (Hi Proyect) y los derechos internacionales de derechos de autor, deberán ser juzgados conforme a ley.'}}
          </v-card-text>
          <v-card-text>
          {{language==='English'?`6- The company claims the Freedom to Modify the Regulations in order to improve and provide a better service to All users.`:'6- La compañía se atribuye la Libertad de Modificar las Regulaciones con el propósito de mejorar y proveer un mejor servicio a Todos los usuarios.'}}
          </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="modalpolicyprivacy = false">{{language==='English'?'Agree':'De acuerdo'}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import { EventBus } from '@/helpers/eventbus/event-bus'
export default {
    data(){
        return{
            language: JSON.parse(localStorage.getItem('language')) !== null ? JSON.parse(localStorage.getItem('language')).language : '',
            modalpolicyprivacy:false
        }
    },
    mounted(){
        EventBus.$on('openmodalpolicyprivacy',()=>{
          this.modalpolicyprivacy = true
        })
    }
}
</script>